import { useEffect, useState } from 'react'
import { Capacitor } from '@capacitor/core'
import { COMMIT } from '../lib/version'
import { readNativeBuild, type NativeBuild } from './buildInfo'
import { tw } from './strings'

export default function ProfileBuildInfo({ environment }: { environment?: string }) {
  const [native, setNative] = useState<NativeBuild>(null)
  useEffect(() => {
    let active = true
    void readNativeBuild().then((info) => { if (active) setNative(info) })
    return () => { active = false }
  }, [])
  const env = environment === 'production' ? tw('w.build.live')
    : environment === 'beta' ? 'Beta'
    : environment === 'local' ? 'Local' : tw('w.build.unknownEnvironment')
  const app = native ? `${tw('w.build.version')} ${native.version} (${tw('w.build.number')} ${native.build})`
    : Capacitor.isNativePlatform() ? tw('w.build.unavailable') : tw('w.build.browser')
  return <footer className="w-build-info" aria-label={tw('w.build.label')}>
    <span>{app}</span><span>{env} · Web {COMMIT}</span>
  </footer>
}
